"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationReducer = exports.INITIAL_STATE = void 0;
const reducer_1 = require("../loading/reducer");
const actions_1 = require("../transaction/actions");
const actions_2 = require("./actions");
const utils_1 = require("./utils");
exports.INITIAL_STATE = {
    data: [],
    loading: [],
    error: null,
    authorizationFlowError: null
};
function authorizationReducer(state = exports.INITIAL_STATE, action) {
    switch (action.type) {
        case actions_2.GRANT_TOKEN_REQUEST:
        case actions_2.REVOKE_TOKEN_REQUEST:
        case actions_2.GRANT_TOKEN_SUCCESS:
        case actions_2.REVOKE_TOKEN_SUCCESS:
        case actions_2.FETCH_AUTHORIZATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { error: null, loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        }
        case actions_2.AUTHORIZATION_FLOW_REQUEST:
        case actions_2.AUTHORIZATION_FLOW_SUCCESS:
            return Object.assign(Object.assign({}, state), { authorizationFlowError: null, loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        case actions_2.AUTHORIZATION_FLOW_FAILURE:
            return Object.assign(Object.assign({}, state), { authorizationFlowError: action.payload.error, loading: (0, reducer_1.loadingReducer)(state.loading, action) });
        case actions_2.FETCH_AUTHORIZATIONS_SUCCESS: {
            const { authorizations } = action.payload;
            // TODO: Optimize with some sort of Map structure to prevent O(n^2)
            // Filters out all authorizations in the state that have been obtained in the fetch to prevent duplication.
            const baseAuthorizations = state.data.filter(stateAuth => !authorizations.some(([original]) => (0, utils_1.areEqual)(original, stateAuth)));
            // Get from the fetched authorizations the ones that are not null.
            const newAuthorizations = authorizations.reduce((acc, next) => {
                const [_, result] = next;
                if (!!result) {
                    acc.push(result);
                }
                return acc;
            }, []);
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: null, 
                // concat the base and new authorizations, without duplications and removing the ones that are now null.
                data: [...baseAuthorizations, ...newAuthorizations] });
        }
        case actions_2.GRANT_TOKEN_FAILURE:
        case actions_2.REVOKE_TOKEN_FAILURE:
        case actions_2.FETCH_AUTHORIZATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), error: action.payload.error });
        }
        case actions_2.AUTHORIZATION_FLOW_CLEAR: {
            return Object.assign(Object.assign({}, state), { loading: (0, reducer_1.loadingReducer)(state.loading, action), authorizationFlowError: null });
        }
        case actions_1.FETCH_TRANSACTION_SUCCESS: {
            const transaction = action.payload.transaction;
            switch (transaction.actionType) {
                case actions_2.GRANT_TOKEN_SUCCESS: {
                    const { authorization } = transaction.payload;
                    const data = state.data.filter(stateAuthorization => !(0, utils_1.areEqual)(stateAuthorization, authorization));
                    data.push(authorization);
                    return Object.assign(Object.assign({}, state), { data });
                }
                case actions_2.REVOKE_TOKEN_SUCCESS: {
                    const { authorization } = transaction.payload;
                    return Object.assign(Object.assign({}, state), { data: [
                            ...state.data.filter(stateAuthorization => !(0, utils_1.areEqual)(stateAuthorization, authorization))
                        ] });
                }
                default:
                    return state;
            }
        }
        default:
            return state;
    }
}
exports.authorizationReducer = authorizationReducer;
//# sourceMappingURL=reducer.js.map